import React from 'react';
import './App.css';
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import Challenges from './components/Challenges';
import Solutions from './components/Solutions';
import DeviceGallery from './components/DeviceGallery';
import Outcomes from './components/Outcomes';
import HowItWorks from './components/HowItWorks';
import PilotProgram from './components/PilotProgram';
import ContactForm from './components/ContactForm';
import FundingSupport from './components/FundingSupport';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <Hero />
        <Challenges />
        <Solutions />
        <DeviceGallery />
        <Outcomes />
        <HowItWorks />
        <PilotProgram />
        <ContactForm />
        <FundingSupport />
        <FAQ />
        <Footer />
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;